module.exports = __webpack_public_path__ + "media/images/emblems/Gambarogno_CoA-7740b6eb628a0ff9dfa73822ce74751c.png";